import { render } from "./login.vue?vue&type=template&id=11767ce8&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=11767ce8&scoped=true&lang=less"

import exportComponent from "D:\\Septris Remake\\septris-remake\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11767ce8"]])

export default __exports__